/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

// function setPriceLeft() {
//     var cartFreeShipping = jQuery("#free-shipping-price[data-free-shipping]").data("freeShipping");
//     var cartCurrentTotal = parseFloat(jQuery(".ajaxcart__footer-total .money").html().slice(0,-3));
// 	jQuery("#free-shipping-price").html(cartFreeShipping - cartCurrentTotal);
// }

// // Update cart shopping message
// $(".js-cart-trigger").click(function() {
// 	setPriceLeft()
// })




    $(document).ready(function () {
        var hiddenTextVisible = false;

        $('#toggle-button').click(function () {
            var splitText = $('#split-text').text().split(' som'); // Split by " som"
            if (hiddenTextVisible) {
                splitText[1] = splitText[1].trim(); // Trim any extra whitespace
                $('#split-text').html(splitText[0]);
                $('#toggle-button').text('Read More');
            } else {
                $('#split-text').html(splitText[0] + '<span id="hidden-text">' + splitText[1] + '</span>');
                $('#toggle-button').text('Hide Text');
            }
            hiddenTextVisible = !hiddenTextVisible;
        });
    });









$(".collection__header-info .collection__header-info__text").click(function() {
  	if ($(this).hasClass("read-more")) {
  		$(this).removeClass("read-more");
    	$(this).height("");
  	} else {
  		$(this).addClass("read-more");
    	$(this).height($(".collection__header-info .collection__header-info__text > p").height() + 24);
  	}
});

$(".product__swatch__item").mouseover(function() {
	var currentProduct = $(this).parents('.js-product');
	var currentProductImage = currentProduct.find('.product__img');
    if (currentProductImage.attr('data-srcset') == '' || typeof attr !== typeof undefined && attr !== false) {
      currentProductImage.attr('data-src-old', currentProductImage.attr('data-srcset'));
    }
  	$(this).click()
});

$(".product__swatch__item").mouseout(function() {
	var currentProduct = $(this).parents('.js-product');
	var currentProductImage = currentProduct.find('.product__img');
  
  	currentProductImage.attr('data-srcset', currentProductImage.attr('data-src-old'));
	currentProductImage.addClass('lazyload');
  
	currentProduct.find('.js-product-swatch-item').removeClass('js-active');
});

$(".js-modal-close").click(function() {
  closeLanguageSwitcher()
})

function languageSwitcher() {
  $("html").addClass("modal-open");
  $(".modal").addClass("modal--is-active");
  
  switchSite();
}

function closeLanguageSwitcher() {
	$(".modal").removeClass("modal--is-active");
  	$("html").removeClass("modal-open");
    $(".modal").addClass("modal--is-closing");
    $("body").addClass("modal-closing");
    window.setTimeout(function() {
    	$("body").removeClass("modal-closing");
		$(".modal").removeClass("modal--is-closing");
	}, 500); // modal close css transition
}

var subscribeBtn = document.querySelector('#mc-embedded-subscribe');

if (subscribeBtn) {
subscribeBtn.addEventListener('click', function(event) {
    // console.log('click')
      var acceptTerms = document.querySelector('#gdpr_70118')
    
      if ( !acceptTerms.checked ) {
        // console.log('acceptTerms 1', acceptTerms);
        event.preventDefault()
        subscribeBtn.setAttribute("disabled", "");
        console.log('validate text is: ', theme.strings.mc_validate);
        subscribeBtn.setAttribute("value", theme.strings.mc_validate);
        // console.log('acceptTerms 2', acceptTerms);
      } else {
        
        subscribeBtn.removeAttribute("disabled", "");
        subscribeBtn.setAttribute("value", theme.strings.become_member);
      }
  })
}

var acceptTermsChk = document.querySelector('#gdpr_70118')

if (acceptTermsChk) {
  
acceptTermsChk.addEventListener('change', function(event) {
    // console.log('click')
    
      if ( acceptTermsChk.checked ) {
        subscribeBtn.removeAttribute("disabled", "");
        subscribeBtn.setAttribute("value", theme.strings.become_member);
        
      }
  else {
  
  event.preventDefault()
        subscribeBtn.setAttribute("disabled", "");
        console.log('validate text is: ', theme.strings.mc_validate);
        subscribeBtn.setAttribute("value", theme.strings.mc_validate);
    
  }
  })
}

if($('.pdp-hero .pdp-media .layout-slider')){
  $(window).on('load',function(){
    if(window.innerWidth<768){
      $('.pdp-hero .pdp-media .layout-slider').slick({
          slidesToShow: 1,
          infinite: false,
          dots: true,
          arrows: false,
          centerMode: true,
          centerPadding: "0"
        });
    }
  }); 
}
